import { render, staticRenderFns } from "./AssignFabricModal.vue?vue&type=template&id=24891ac0&"
import script from "./AssignFabricModal.vue?vue&type=script&lang=js&"
export * from "./AssignFabricModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignFabricModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports